// extracted by mini-css-extract-plugin
export default {"task_widgets":"amLZ2","error_container":"rRLWX"};